module.exports = __webpack_public_path__ + "static/media/5f60c89df40ac.1d36e370.jpg";